import { getCurrencySymbol, formatCurrency } from '@angular/common';

const DEFAULT_CURRENCY_SYMBOL = getCurrencySymbol('NZD', 'narrow');

export function currencyFormatter(dataItemValue: number, locale: string = 'en-NZ', currencySymbol: string = DEFAULT_CURRENCY_SYMBOL) {
  return formatCurrency(dataItemValue, locale, currencySymbol);
}
